module.exports = __webpack_public_path__ + "img/wedo2.a937599f.png";